import React, { useContext } from "react";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import { useAuthProvider, Loader, getBaseUrl, getParam, callApi, PortalUser, DataContext, User } from "@cloudpremise/portal_core";
import { useNavigate } from "react-router-dom";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import Card from "@mui/material/Card";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";

// @mui material components
import Grid from "@mui/material/Grid";

import Config from "../../../../Config";

const LoginWithGoogle = (props) => {
    const dataProvider = useContext(DataContext);
    const [ authorized, authType ] = useAuthProvider();
    const [controller, dispatch] = useMaterialUIController();
    const navigate = useNavigate();
    const REDIRECT_URI = window.origin + getBaseUrl() + "/auth/google";
    React.useEffect(() => {
        if(authorized && authType === "google"){
            return navigate("/home", { replace: true });
        }
        const googleLogin = localStorage.getItem("google_login");
        if(googleLogin === "1"){
            const authCode = getParam('code');
            const object: PortalUser = {
                sObjectTypeName: "PortalUser",
                url: '/v1/identity/verification/google',
                method: 'POST',
                headers: {},
                data: {
                    code: decodeURIComponent(authCode),
                    redirectUri: REDIRECT_URI
                }
            };
            callApi(dataProvider, object).then((data: any) => {
                if(data && Array.isArray(data?.result) && data.result.length > 0){
                    const verifiedEntity = new User(data.result[0]);
                    localStorage.setItem("google_login", "1");
                    localStorage.setItem("identity_token", verifiedEntity.token);
                    localStorage.setItem("verified_entity", JSON.stringify(verifiedEntity));
                    localStorage.setItem("login_type", "google");
                    // verifiedEntity.token = null;
                    dispatch({value: {user: verifiedEntity}, type: "UPDATE_STATE"});
                    navigate("/home", { replace: true });
                }
                // setState({dynamicObjectType: response.result, loading: false, formSaved: true});
            }).catch((err) => {
                let errorMessage = null;
                // if(typeof(err) === "object" && err.hasOwnProperty("error")){
                //     errorMessage = err.error;
                // }else if(typeof(err) === "object" && err.hasOwnProperty("message")){
                //     errorMessage = err.message;
                // }
                // setState({loading: false, errorMessage: errorMessage});
            });

            // localStorage.removeItem("google_login");
        }else{
            const CLIENT_ID = Config.getGoogleClientId(); // Replace with yours
            let authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=openid profile email&prompt=select_account`;
            localStorage.removeItem("reactforce_logout");
            localStorage.setItem("google_login", "1");
            window.location.href = authUrl;
        }
    });
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={3}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12} md={7} lg={5} py={{ xs: 0, sm: 2 }} ml="auto" mr="auto" position="relative">
                        <MDBox component="form" role="form">
                            <Card style={{borderRadius: "xs"}}>
                                <MDBox
                                    variant="contained"
                                    bgColor="transparent"
                                    borderRadius="sm"
                                    coloredShadow="none"
                                    p={2}
                                    textAlign="left"
                                >
                                    <Loader color="info" />
                                </MDBox>
                            </Card>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
};

export default LoginWithGoogle;